(function(){
  var LIME = "#ccff33";
  var cats = [
    {n:"Road Running", u:"/collections/training", img:"https://cdn.shopify.com/s/files/1/1063/9474/7221/collections/A10D9A4A-7123-4C40-99DC-B40975B41A65.jpg?v=1784929674", pos:"center 30%"},
    {n:"Trail Running", u:"/collections/trail", img:"https://cdn.shopify.com/s/files/1/1063/9474/7221/collections/3497120F-40E6-4308-BA31-0FB6F73495B2.jpg?v=1784929931", pos:"center 38%"},
    {n:"Race Day", u:"/collections/racing", img:"https://cdn.shopify.com/s/files/1/1063/9474/7221/collections/5DD286D6-8813-44F1-8665-ABF705C9B37D.jpg?v=1784927848", pos:"center 28%"},
    {n:"Lifestyle", u:"/collections/lifestyle", img:"https://cdn.shopify.com/s/files/1/1063/9474/7221/collections/541E8461-C431-4F46-AF43-03D0E431562A.jpg?v=1784929735", pos:"center 42%"}
  ];
  var brands = [["Nike","/collections/nike"],["On","/collections/on"],["Hoka","/collections/hoka"],["Asics","/collections/asics"],["New Balance","/collections/new-balance"],["Adidas","/collections/adidas"],["Brooks","/collections/brooks"],["Saucony","/collections/saucony"],["Puma","/collections/puma"],["Salomon","/collections/salomon"]];
  var ARW = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="'+LIME+'" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"></path></svg>';
  var CH = '<span class="rp-ch">&rsaquo;</span>';

  var CSS = [
    ".rpmenu{padding:8px 16px 30px;font-family:inherit;-webkit-font-smoothing:antialiased}",
    ".rpmenu *{box-sizing:border-box}",
    ".rpmenu .rp-srch{display:flex;align-items:center;gap:10px;height:46px;background:#f3f3f2;border-radius:12px;padding:0 6px 0 14px;margin:4px 0 6px}",
    ".rpmenu .rp-srch svg{display:block;flex:0 0 auto}",
    ".rpmenu .rp-srch input{border:0;background:transparent;flex:1;font-size:15px;outline:none;color:#111;min-width:0}",
    ".rpmenu .rp-srch button{width:34px;height:34px;border:0;border-radius:9px;background:"+LIME+";display:flex;align-items:center;justify-content:center;cursor:pointer;flex:0 0 auto}",
    ".rpmenu .rp-lab{font-size:11px;font-weight:800;letter-spacing:.14em;text-transform:uppercase;color:#8a8a8a;margin:16px 2px 12px}",
    ".rpmenu .rp-grid{display:grid !important;grid-template-columns:1fr 1fr !important;gap:10px}",
    ".rpmenu .rp-card{position:relative;height:150px;border-radius:16px;overflow:hidden;display:block;background:#eee;text-decoration:none}",
    ".rpmenu .rp-card .rp-ph{position:absolute;inset:0;background-size:cover;background-repeat:no-repeat}",
    ".rpmenu .rp-card .rp-g{position:absolute;inset:0;background:linear-gradient(180deg,rgba(0,0,0,.1) 0%,rgba(0,0,0,0) 36%,rgba(0,0,0,0) 50%,rgba(0,0,0,.6))}",
    ".rpmenu .rp-card .rp-row{position:absolute;left:14px;right:12px;bottom:13px;display:flex;align-items:center;gap:7px}",
    ".rpmenu .rp-card .rp-nm{color:#fff;font-weight:800;font-size:16px;letter-spacing:-.01em;text-shadow:0 1px 6px rgba(0,0,0,.55)}",
    ".rpmenu .rp-card .rp-row svg{filter:drop-shadow(0 1px 3px rgba(0,0,0,.4))}",
    ".rpmenu .rp-sec{border-bottom:1px solid #ededed}",
    ".rpmenu .rp-sec>a,.rpmenu .rp-sec>button{display:flex;align-items:center;justify-content:space-between;width:100%;background:none;border:0;padding:15px 0;font-size:20px;font-weight:800;letter-spacing:-.02em;color:#111;text-decoration:none;cursor:pointer;font-family:inherit;text-align:left;line-height:1.1}",
    ".rpmenu .rp-sec .rp-pm{font-size:22px;font-weight:400;color:#111}",
    ".rpmenu .rp-ch{color:#c4c4c4;font-weight:400;font-size:18px}",
    ".rpmenu .rp-brands{display:none;padding:0 4px 10px}",
    ".rpmenu .rp-brands.rp-open{display:block}",
    ".rpmenu .rp-brands a{display:flex;align-items:center;justify-content:space-between;padding:10px 0;font-size:16px;font-weight:700;color:#111;text-decoration:none;border-bottom:1px solid #f4f4f4}",
    ".rpmenu .rp-svc{margin-top:18px;padding-top:14px;border-top:1px solid #ededed}",
    ".rpmenu .rp-svc a{display:flex;align-items:center;justify-content:space-between;padding:12px 0;font-size:15.5px;font-weight:600;color:#1c1c1c;text-decoration:none;border-bottom:1px solid #f5f5f5}",
    ".menu-drawer .menu-drawer__navigation-container>.rpmenu{width:100%}"
  ].join("");

  function cardHTML(k){
    return '<a class="rp-card" href="'+k.u+'"><span class="rp-ph"></span><span class="rp-g"></span><span class="rp-row"><span class="rp-nm">'+k.n+'</span>'+ARW+'</span></a>';
  }
  function brandsHTML(){
    var s = "";
    for(var i=0;i<brands.length;i++){ s += '<a href="'+brands[i][1]+'">'+brands[i][0]+CH+'</a>'; }
    return s;
  }
  function menuHTML(){
    var grid = "";
    for(var i=0;i<cats.length;i++){ grid += cardHTML(cats[i]); }
    return ''
      + '<form class="rp-srch" action="/search" method="get" role="search">'
      +   '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9a9a9a" stroke-width="2"><circle cx="11" cy="11" r="7"></circle><path d="M20 20l-3.5-3.5"></path></svg>'
      +   '<input type="search" name="q" placeholder="Search shoes..." aria-label="Search">'
      +   '<button type="submit" aria-label="Search"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="2.4"><circle cx="11" cy="11" r="7"></circle><path d="M20 20l-3.5-3.5"></path></svg></button>'
      + '</form>'
      + '<div class="rp-lab">Shop by category</div>'
      + '<div class="rp-grid">'+grid+'</div>'
      + '<div class="rp-acc">'
      +   '<div class="rp-sec"><a href="/collections/best-sellers">Best Sellers'+CH+'</a></div>'
      +   '<div class="rp-sec"><a href="/collections/nouveautes">New Arrivals'+CH+'</a></div>'
      +   '<div class="rp-sec"><button class="rp-brandtoggle" type="button">Shop by brand<span class="rp-pm">+</span></button><div class="rp-brands">'+brandsHTML()+'</div></div>'
      + '</div>'
      + '<div class="rp-svc">'
      +   '<a href="/pages/authenticity-guarantee-1">Authenticity Guarantee'+CH+'</a>'
      +   '<a href="/apps/17TRACK">Track your order'+CH+'</a>'
      +   '<a href="/pages/contact">Contact us'+CH+'</a>'
      +   '<a href="/account">My account'+CH+'</a>'
      + '</div>';
  }
  function injectCSS(){
    if(document.getElementById("rpmenu-css")) return;
    var st = document.createElement("style");
    st.id = "rpmenu-css";
    st.textContent = CSS;
    (document.head||document.documentElement).appendChild(st);
  }
  function build(){
    injectCSS();
    var drawers = document.querySelectorAll(".menu-drawer");
    for(var d=0; d<drawers.length; d++){
      var md = drawers[d];
      if(md.querySelector(".rpmenu")) continue;
      var nav = md.querySelector(".menu-drawer__navigation"); if(nav) nav.style.display="none";
      var ut = md.querySelector(".menu-drawer__utility-links"); if(ut) ut.style.display="none";
      var fc = md.querySelector(".menu-drawer__featured-content"); if(fc) fc.style.display="none";
      var host = md.querySelector(".menu-drawer__navigation-container") || md;
      var wrap = document.createElement("div");
      wrap.className = "rpmenu";
      wrap.innerHTML = menuHTML();
      host.appendChild(wrap);
      var phs = wrap.querySelectorAll(".rp-ph");
      for(var i=0;i<phs.length;i++){
        phs[i].style.backgroundImage = "url(" + cats[i].img + ")";
        phs[i].style.backgroundPosition = cats[i].pos;
      }
      var bt = wrap.querySelector(".rp-brandtoggle");
      if(bt){
        bt.addEventListener("click", function(ev){
          ev.preventDefault();
          var box = this.parentNode.querySelector(".rp-brands");
          var pm = this.querySelector(".rp-pm");
          if(box.classList.contains("rp-open")){ box.classList.remove("rp-open"); if(pm) pm.textContent="+"; }
          else { box.classList.add("rp-open"); if(pm) pm.textContent="-"; }
        });
      }
    }
  }
  function boot(){
    injectCSS();
    build();
    if(window.MutationObserver){
      var scheduled = false;
      var obs = new MutationObserver(function(){
        if(scheduled) return;
        scheduled = true;
        window.setTimeout(function(){ scheduled = false; build(); }, 80);
      });
      obs.observe(document.documentElement, {childList:true, subtree:true});
    }
    document.addEventListener("click", function(e){
      var t = e.target;
      if(t && t.closest && t.closest(".header__icon--menu, header-drawer summary, .menu-drawer__close-button")){
        window.setTimeout(build, 0);
        window.setTimeout(build, 120);
      }
    }, true);
    var n = 0;
    var iv = window.setInterval(function(){ build(); n++; if(n>20) window.clearInterval(iv); }, 400);
  }
  if(document.readyState!=="loading") boot(); else document.addEventListener("DOMContentLoaded", boot);
})();
